import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuConfiguration } from 'src/business/models/main-configuration.model';
import { MediaModule } from 'src/layout/media/media.module';
import { StorageUtil } from 'src/utils/storage.util';

@Component({
    selector: 'app-footer-cards',
    templateUrl: './footer-cards.component.html',
    styleUrls: ['./footer-cards.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule, MediaModule],
    standalone: true,
})
export class FooterCardsComponent {
    menu: Partial<MenuConfiguration> = StorageUtil.get<MenuConfiguration>('menu');
    @HostBinding('attr.aria-hidden') ariahidden = this?.menu?.paymentOptions?.length > 0 ? null : '';
    @HostBinding('attr.aria-label') ariaLabel = this._translateService.instant('FOOTER.CARDS_LABEL')
    constructor(private _translateService: TranslateService) {}

}
